export default __webpack_public_path__ + "static/media/ninteen.8b42e92f.jpg";